import ModelIdist from "./idist/ModelIdist";

export const UserM = new ModelIdist('User');
export const AccountM = new ModelIdist('Account');
export const TagM = new ModelIdist('Tag');
export const ToolM = new ModelIdist('Tool');
export const ToolTagM = new ModelIdist('ToolTag');
export const ToolLikeM = new ModelIdist('ToolLike');
export const ToolViewM = new ModelIdist('ToolView');
export const ToolSaveM = new ModelIdist('ToolSave');
export const ToolCommentM = new ModelIdist('ToolComment');
